export default {
  manager_issue:
    "Includes <b>Superseded</b> and <b>Rejected</b> <b class='text-info'>Issue</b> count",
  manager_work_order:
    "Includes <b class='text-info'>Work Orders</b> managed by, but not assigned to, you",
  technician_issue:
    "Includes <b>Superseded</b> and <b>Rejected</b> <b class='text-info'>Issue</b> count",
  technician_work_order:
    "Includes <b class='text-info'>Work Orders</b> managed by, but not assigned to, you",
  todo_on_work_order:
    "On the <b class='text-info'>Work Order</b>, <u>not</u> <span class='text-positive'>Performed</span>",
  performed_on_work_order:
    "On the <b class='text-info'>Work Order</b> <u>and</u> <span class='text-positive'>Performed</span>",
  has_identifier: "Has <b class='text-info'>identifier</b>",
  work_order: "Added to <b class='text-info'>Work Order</b>",
  issue: "<b class='text-info'>Issue</b> added",
  change_request: "<b class='text-info'>Change Request</b> made",
  done: "This is done.",
  corrective_work: "<b class='text-info'>Corrective Work</b> performed",
  issue_overdue: "<b class='text-info'>Issue</b> is overdue!",
  corrective_work_accepted: "<b class='text-info'>Corrective Work</b> accepted",
  closed: "Closed",
  from_designation: "From <span class='text-info'>Designation</span>",
  from_group: "From <span class='text-info'>Group</span>",
  from_organisation: "From <span class='text-info'>Organisation</span>",
}
